import {Box, Button, CircularProgress, Paper, Stack, TextField, Typography} from '@mui/material';
import React, {useState} from 'react';
import axios from 'axios';
import {NotificationManager} from 'react-notifications';
import {API_ENDPOINT} from '../config';
import {useAuth} from '../auth/AuthContext';

const ContactPage = () => {
    const {auth, logout} = useAuth();
    const [subject, setSubject] = useState('');
    const [message, setMessage] = useState('');
    const [sending, setSending] = useState(false);

    const senderEmail = (() => {
        try {
            const payload = JSON.parse(atob(auth.token.split('.')[1]));
            return payload.username || payload.email || '';
        } catch {
            return '';
        }
    })();

    const handleSubmit = async () => {
        if (subject.trim().length < 3) {
            NotificationManager.warning('Subiectul trebuie să aibă minim 3 caractere.');
            return;
        }
        if (message.trim().length < 10) {
            NotificationManager.warning('Mesajul trebuie să aibă minim 10 caractere.');
            return;
        }
        setSending(true);
        try {
            await axios.post(
                `${API_ENDPOINT}/v1/me/contact`,
                {subject, message},
                {headers: {Authorization: `Bearer ${auth.token}`}}
            );
            NotificationManager.success('Mesajul a fost trimis. Vă mulțumim!');
            setSubject('');
            setMessage('');
        } catch (err) {
            if (err.response?.status === 401) {
                logout();
            } else {
                NotificationManager.error(err.response?.data?.error || 'Nu am putut trimite mesajul.');
            }
        } finally {
            setSending(false);
        }
    };

    return <Box sx={{maxWidth: 720, mx: 'auto', px: 2, py: 4}}>
        <Typography component="h1" variant="h4" sx={{mb: 3}}>Contact</Typography>
        <Paper variant="outlined" sx={{p: {xs: 2, sm: 3}}}>
            <Typography component="h2" variant="h6" sx={{mb: 3}}>Trimite un mesaj administratorului</Typography>
            <Stack component="form" spacing={3} onSubmit={event => {event.preventDefault(); if (!sending) handleSubmit();}}>
                {senderEmail && <TextField label="De la" type="email" value={senderEmail} disabled />}
                <TextField label="Subiect" placeholder="Despre ce este vorba?" value={subject} onChange={e => setSubject(e.target.value)} disabled={sending} />
                <TextField label="Mesaj" placeholder="Scrieți mesajul dumneavoastră..." multiline rows={6} value={message} onChange={e => setMessage(e.target.value)} disabled={sending} />
                <Button type="submit" variant="contained" disabled={sending} startIcon={sending ? <CircularProgress size={18} color="inherit" /> : undefined}>{sending ? 'Se trimite…' : 'Trimite'}</Button>
            </Stack>
        </Paper>
    </Box>;
};

export default ContactPage;
